import Image from './_image.js'
import AbsolutePane from './_absolute-pane.js'
import BannerMarket from './_banner-market.js'

export default {
  name: 'BannerPromotion',
  values: {
    image: {
      configSet: Image,
      configValues: {
        style: {
          width: '100%',
          height: '100%',
          flexGrow: 1,
          cursor: 'pointer',
        },
      },
    },
    marketOverlay: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          height: '100px',
          width: '100%',
          bottom: 0,
        },
      },
    },
    bannerMarket: {
      configSet: BannerMarket,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
